import _slicedToArray from '@babel/runtime-corejs3/helpers/esm/slicedToArray';
import { useRef, useState, useCallback } from 'react';

var useDragPosition = function useDragPosition(eventToPosition, onDrag) {
  var position = useRef({
    horizontalChange: 0,
    verticalChange: 0
  });
  var isDraggingRef = useRef(false);
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    isDragging = _useState2[0],
    setIsDragging = _useState2[1];
  var handleDragStart = useCallback(function (event) {
    position.current = eventToPosition(event);
    isDraggingRef.current = true;
    setIsDragging(true);
  }, [eventToPosition]);
  var handleDragMove = useCallback(function (event) {
    event.stopPropagation();
    if (!isDraggingRef.current) return;
    if (event.cancelable) event.preventDefault();
    var newPosition = eventToPosition(event);
    onDrag({
      horizontalChange: newPosition.horizontalChange - position.current.horizontalChange,
      verticalChange: newPosition.verticalChange - position.current.verticalChange
    }, event);
    position.current = newPosition;
  }, [eventToPosition, onDrag]);
  var handleDragEnd = useCallback(function () {
    isDraggingRef.current = false;
    setIsDragging(false);
  }, []);
  return {
    isDragging: isDragging,
    handleDragStart: handleDragStart,
    handleDragMove: handleDragMove,
    handleDragEnd: handleDragEnd
  };
};

export { useDragPosition as default };
//# sourceMappingURL=useDragPosition.js.map
